import { PlayFilled } from "@aircall/icons";
import { Icon, Tooltip, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { ItemActionsProps } from "./TranscriptionItemActions.decl";
import * as S from "./TranscriptionItemActions.styled";

import { useSeekAndScroll } from "@/hooks/useSeekAndScroll/useSeekAndScroll";
import { useTrackPlaying } from "@/hooks/useTrackPlaying/useTrackPlaying";

export function TranscriptionItemActions({
  utterance,
  displayedStartTime,
}: ItemActionsProps) {
  const { startTime } = utterance;
  const { seekAndScroll } = useSeekAndScroll(startTime);
  const { t } = useTranslation();

  const onClick = useTrackPlaying("transcript");

  const handleOnClick = () => {
    seekAndScroll();
    onClick();
  };

  return (
    <S.ItemActions
      onClick={handleOnClick}
      data-test="transcript-item-play-icon"
    >
      <Tooltip title={t("play_icon_tooltip")}>
        <Icon component={PlayFilled} color="icon-disabled" size="20" />
      </Tooltip>
      <Typography
        data-test={`transcript-item-start-time-${displayedStartTime}`}
        variant="bodyRegularS"
      >
        {displayedStartTime}
      </Typography>
    </S.ItemActions>
  );
}
